var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "ml-2 mt-1 feedback--animation",
      staticStyle: { "enable-background": "new 0 0 512 512" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        "xml:space": "preserve",
        width: _vm.width,
        height: _vm.height,
        role: "presentation"
      }
    },
    [
      _c("g", { attrs: { fill: _vm.iconColor } }, [
        _c("path", {
          attrs: {
            d:
              "m457.597656 0h-403.195312c-29.996094 0-54.402344 24.40625-54.402344 54.402344v239.761718c0 30 24.40625 54.402344 54.402344 54.402344h56.363281v98.355469c0 6.210937 3.753906 11.808594 9.503906 14.160156 1.875.765625 3.839844 1.140625 5.789063 1.140625 4.027344 0 7.980468-1.589844 10.914062-4.578125l107.207032-109.078125h213.417968c29.996094 0 54.402344-24.402344 54.402344-54.402344v-239.761718c0-29.996094-24.40625-54.402344-54.402344-54.402344zm23.804688 294.164062c0 13.125-10.679688 23.804688-23.804688 23.804688h-219.835937c-4.101563 0-8.035157 1.648438-10.910157 4.574219l-85.488281 86.988281v-76.261719c0-8.449219-6.851562-15.300781-15.300781-15.300781h-71.660156c-13.125 0-23.804688-10.679688-23.804688-23.804688v-239.761718c0-13.125 10.679688-23.804688 23.804688-23.804688h403.195312c13.125 0 23.804688 10.679688 23.804688 23.804688zm0 0"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "m294.738281 83.949219c-14.503906 0-28.167969 5.265625-38.738281 14.441406-10.570312-9.175781-24.238281-14.441406-38.738281-14.441406-32.605469 0-59.128907 26.527343-59.128907 59.128906 0 66.257813 86.851563 114.328125 90.550782 116.339844 2.277344 1.242187 4.796875 1.863281 7.316406 1.863281s5.035156-.621094 7.316406-1.863281c3.699219-2.015625 90.550782-50.082031 90.550782-116.339844 0-32.605469-26.523438-59.128906-59.128907-59.128906zm-38.753906 144.304687c-23.890625-14.839844-67.253906-49.214844-67.253906-85.175781 0-15.730469 12.796875-28.53125 28.53125-28.53125 10.585937 0 20.25 5.824219 25.222656 15.195313 2.652344 5.003906 7.851563 8.132812 13.515625 8.132812s10.863281-3.128906 13.515625-8.132812c4.972656-9.371094 14.636719-15.195313 25.222656-15.195313 15.734375 0 28.53125 12.800781 28.53125 28.53125 0 35.824219-43.394531 70.28125-67.285156 85.175781zm0 0"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }